import SortList from './sortListComponent';

export default SortList;
